"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Dialogue = function Dialogue(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 18.881a7.987 7.987 0 01-1.466-.155.808.808 0 00-.642.166 6.59 6.59 0 01-3.142 1.235.34.34 0 01-.318-.53c.44-.547.755-1.184.925-1.865a.504.504 0 00-.188-.49 6.612 6.612 0 01-2.669-5.236c0-3.792 3.358-6.875 7.5-6.875 4.142 0 7.5 3.083 7.5 6.876 0 3.792-3.358 6.874-7.5 6.874zm0-2.5a.937.937 0 100-1.874.937.937 0 000 1.874zm0-8.75c-1.38 0-2.5.98-2.5 2.188-.002.24.028.478.09.709.038.135.162.229.303.229h.635a.311.311 0 00.293-.414 1.604 1.604 0 01-.08-.524c0-.518.596-.938 1.2-.938.605 0 1.192.42 1.192.938 0 1.557-1.758 1.361-1.758 3.438 0 .172.14.312.312.312h.704c.172 0 .312-.14.312-.313 0-1.51 1.797-1.432 1.797-3.437 0-1.208-1.119-2.188-2.5-2.188z"
  }));
};

var _default = (0, _react.forwardRef)(Dialogue);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Dialogue, "Dialogue", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dialogue.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dialogue.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();